import _ from 'lodash';
import React from 'react';

import { motionFadeUpProps } from '_/configs/motion-presets';

import { Card, CardProps } from '@/components/chakra-ui';
import { MotionHeading, MotionHeadingProps } from '@/components/chakra-ui/framer-motion';
import { GeneralSection, GeneralSectionProps } from '@/layout';

export interface WorksSectionLayoutProps {
  // OPTIONAL
  title?: string;
  titleProps?: MotionHeadingProps;
  cardProps?: CardProps;
  sectionProps?: GeneralSectionProps;
}

const WorksSectionLayout = ({
  // OPTIONAL
  title,
  titleProps,
  cardProps,
  sectionProps,
}: WorksSectionLayoutProps): JSX.Element => (
  <GeneralSection sectionProps={{ overflow: `visible` }} {...sectionProps}>
    <MotionHeading
      key={`works-section-title-${title}`}
      as="h2"
      p="0 1.8rem"
      textStyle="heading-sm"
      {...motionFadeUpProps}
      {...titleProps}
    >
      {title}
    </MotionHeading>
    <Card {...cardProps} />
  </GeneralSection>
);

export default WorksSectionLayout;
